import { styled } from 'styled-components';

import PromotionsSVG from '../assets/promotions-icon.svg?react';

export const StyledPromotionsIcon = styled(PromotionsSVG)`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
`;
